<template>
  <div>
    <b-alert show variant="warning">
      <mdicon name="information" size="24" class="mr-1" />
      <span
        v-text="$lang.azmoonLang.choose_azmoon_execute_person_description"
      />
    </b-alert>
    <b-form @submit.prevent="submit">
      <b-row>
        <b-col cols="12" md="12">
          <b-form-group
            :label="$lang.sample_name"
            label-for="sampleName"
            :label-cols="$config.azmoon.form.labelCol"
          >
            <requiredComponent
              slot="label"
              :label="$lang.sample_name"
              :rules="$v.sampleName.$params"
            />
            <b-form-input
              id="sampleName"
              type="text"
              autocomplete="off"
              v-model="$v.sampleName.$model"
              :state="$v.sampleName.$dirty ? !$v.sampleName.$error : null"
            >
            </b-form-input>
            <b-form-invalid-feedback id="sampleName-feedback"
              >{{
                $lang.azmoonLang.error_required | replace($lang.sample_name)
              }}
            </b-form-invalid-feedback>
          </b-form-group>
        </b-col>
        <b-col cols="12" md="12">
          <b-form-group>
            <requiredComponent
              slot="label"
              :label="$lang.azmoon_term_state"
              :rules="$v.termState.$params"
            />
            <selectFind
              :options="termStateOptions"
              v-model="$v.termState.$model"
              label="caption"
              id="id"
              :isValid="$v.termState.$dirty ? !$v.termState.$error : null"
              :loading="termStateLoading"
            />
            <b-form-invalid-feedback
              :state="$v.termState.$dirty ? !$v.termState.$error : null"
            >
              <div v-if="!$v.termState.required">
                {{ $lang.error_required | replace($lang.azmoon_term_state) }}
              </div>
            </b-form-invalid-feedback>
          </b-form-group>
        </b-col>
        <b-col cols="12" md="12" class="float-right">
          <div slot="footer" class="form-group form-btn">
            <b-button
              type="reset"
              class="mr-2"
              variant="outline-danger"
              @click="close"
            >
              <mdicon name="close" size="24" />
              {{ $lang.azmoonLang.cancelButton }}
            </b-button>
            <b-button type="submit" variant="success">
              <mdicon name="check" size="24" />
              {{ $lang.azmoonLang.submitButton }}
            </b-button>
          </div>
        </b-col>
      </b-row>
    </b-form>
  </div>
</template>

<script>
import { required } from "vuelidate/lib/validators";
import { pathOr } from "ramda";
import { generateApiUrl } from "@/shared/utils";

export default {
  name: "show-name-form",
  validations: {
    sampleName: { required },
    termState: {},
  },
  data() {
    return {
      sampleName: null,
      termStateLoading: false,
      termStateOptions: null,
      termState: null,
    };
  },
  props: {
    item: {
      type: Object,
      default: null,
    },
    termCode: {
      type: [Number, String],
      default: null,
    },
  },
  watch: {
    item: {
      immediate: true,
      handler(value) {
        value && this.fetchData();
      },
    },
  },
  created() {
    this.getTermStateCombo();
  },
  methods: {
    pathOr,
    generateApiUrl,
    close() {
      this.$emit("close");
    },
    submit() {
      const payload = {
        exam_pack_show_name: this.sampleName,
        term_state_id: pathOr(null, ["id"], this.termState),
      };
      this.$emit("submit", payload);
    },
    async getTermStateCombo() {
      this.termStateOptions = [];
      try {
        this.termStateLoading = true;
        const url = generateApiUrl(
          ["azmoon", "azmoon_term_state_id"],
          [this.termCode]
        );
        const response = await this.$httpService.get(url);
        const data = pathOr([], ["data", "data"], response);
        this.termStateOptions = data.map((item) => {
          return {
            caption: pathOr(null, ["state_caption"], item),
            id: pathOr(null, ["id"], item),
          };
        });
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.termStateLoading = false;
      }
    },
    fetchData() {
      this.sampleName = pathOr(null, ["exam_pack_show_name"], this.item);
      this.termState = {
        id: pathOr(null, ["term_state", "id"], this.item),
        caption: pathOr(null, ["term_state", "state_caption"], this.item),
      };
    },
  },
};
</script>
